// import './App.css';
import { useCallback, useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import API from './service/api';
import { ws } from './service/ws';
import { I18nextProvider, useTranslation } from 'react-i18next';
import { LoadingSpinner } from './components/LoadingSpinner';
import { MainPage } from './pages';
import { AuthPage } from './pages/auth';
import { JoinPage } from './pages/join';
import { ReportsLayout } from './pages/reports/layout';
import { ProfileLayout } from './pages/profile/layout';
import { ResetPasswordPage } from './pages/reset';
import { host } from './service/host';
import i18n from './i18n';
import { UserDataDTO } from '@scm/common-legacy';

function App() {
    const [loading, setLoading] = useState(true);
    const [loadingHostData, setLoadingHostData] = useState(true);
    const [loginError, setLoginError] = useState('');
    const { t } = useTranslation();
    /** user data */
    const [userData, setUserData] = useState<UserDataDTO | null>(null);
    // const [user, setUser] = useState(null); //id si nume
    // const [company, setCompany] = useState(null); //id si nume

    useEffect(() => {
        getHostData();
        return () => {
            if (ws.isConnected()) {
                ws.off('newRights', getMyData);
            }
        };
    }, []);

    const getMyData = useCallback(async () => {
        setLoading(true);
        try {
            setUserData((await API.GET('/api/users')) as UserDataDTO);
        } catch (err) {
            setLoginError(t('token_expired'));
            localStorage.removeItem('token');
            setLoading(false);
            return;
        }
        try {
            await initializeWS();
        } catch (err: any) {
            alert('Failed to initialize WS connection: ' + err.message);
        }
        setLoading(false);
    }, []);

    const getHostData = useCallback(async () => {
        try {
            await host.getData();
        } catch (err) {
        } finally {
            setLoadingHostData(false);
        }
    }, []);

    const initializeWS = useCallback(async () => {
        if (!ws.isStarted()) {
            ws.start();
            ws.on('newRights', getMyData);
        }
    }, [ws, getMyData]);

    useEffect(() => {
        API.onLogout = () => {
            setUserData(null);
        };
        API.token = localStorage.getItem('token') || '';
        if (API.token) getMyData();
        else setLoading(false);
    }, []);

    if (loading || loadingHostData) return <LoadingSpinner />;

    return (
        <I18nextProvider i18n={i18n}>
            <BrowserRouter>
                <Routes>
                    <Route
                        path="*"
                        element={
                            userData !== null ? (
                                <MainPage
                                    userName={userData.name}
                                    companyName={userData.company.name}
                                />
                            ) : (
                                <Navigate to="/auth" />
                            )
                        }
                    />
                    <Route
                        path="auth"
                        element={
                            userData !== null ? (
                                <Navigate to="/" />
                            ) : (
                                <AuthPage
                                    onLogin={getMyData}
                                    initialError={loginError}
                                />
                            )
                        }
                    />
                    <Route path="reset" element={<ResetPasswordPage />} />
                    <Route
                        path="profile/*"
                        element={
                            userData !== null ? (
                                <ProfileLayout
                                    userData={userData}
                                    onUserUpdate={getMyData}
                                />
                            ) : (
                                <Navigate to="/auth" />
                            )
                        }
                    />
                    <Route
                        path="join"
                        element={<JoinPage onLogin={getMyData} />}
                    />
                    <Route path="reports/*" element={<ReportsLayout />} />
                    <Route path="*" element={<Navigate to="/" />} />
                </Routes>
            </BrowserRouter>
        </I18nextProvider>
    );
}

export default App;
